import i18n from '@/i18n/index.js'

export default {
    toHumanDate(ctx){


        var date = "";
        var time = "";

        
        if(typeof ctx == "string" && ctx.includes("T")){
            ctx = ctx.split("T");
            date = ctx[0].split("-");
            date = date[2] + "." + date[1] + "." + date[0];

            time = ctx[1].split(":");
            time = time[0] + ":" + time[1] + ":" + time[2].substring(0, 2)

            ctx = date + " "+ i18n.t('at') +"  " + time + " " + i18n.t('oclock')
        }else if(typeof ctx == "string" && ctx.includes("-") && ctx.includes(":")){

            ctx = ctx.split(" ")

            date = ctx[0].split("-")
            date = date[2] + "." + date[1] + "." + date[0]

            time = ctx[1].split(":")
            time = time[0] + ":" + time[1] + ":" + time[2].substring(0, 2)
            ctx = date + " "+ i18n.t('at') +"  " + time + " " + i18n.t('oclock')
        }else if(typeof ctx == "string" && ctx.includes("-")){
            ctx = ctx.split("-")
            ctx = ctx[2] + "." + ctx[1] + "." + ctx[0]
        }else if(typeof ctx == "number"){
            ctx = ctx * 1000;
            ctx = new Date(ctx).toISOString();
          //  ctx = ctx.getDate() + "." + ctx.getMonth() + 1 + "." + ctx.getFullYear
            ctx = ctx.split("T");
            ctx = ctx[0].split("-");
            ctx = ctx[2] + "." + ctx[1] + "." + ctx[0];

            time = ctx[1].split(":");
            time = time[0] + ":" + time[1] + ":" + time[2].substring(0, 2)

            ctx = date + " "+ i18n.t('at') +"  " + time + " " + i18n.t('oclock')
        }else if(typeof ctx == "string" && (ctx.includes("um") || ctx.includes("at"))){
            ctx = ctx.split(" ")
            ctx = ctx[0] + " " + i18n.t("at") + " " + ctx[2] + " " + i18n.t("oclock")         
        }
        return ctx;
    },

    toSQLDate(ctx){
        var date = "";
        var time = "";
        ctx = ctx.toLocaleString()
      //  date = ctx.getFullYear() + "-" + (ctx.getUTCMonth() + 1) + "-" + ctx.getDate() + " " + ctx.getUTCHours()+":"+ctx.getUTCMinutes()+":"+ctx.getUTCSeconds()
        ctx = ctx.replaceAll(",", "");
        date = ctx.split(" ")[0]
        date = date.split(".")
        date[1].length == 1 ? date[1] = "0" + date[1] : ""
        date[0].length == 1 ? date[0] = "0" + date[0] : ""
        date = date[2] + "-" + date[1] + "-" + date[0]

        time = ctx.split(" ")[1]

        ctx = date+" "+time
        return ctx;
    }
}